import {Contact} from './contact.model';
import {JsonProperty} from 'json-typescript-mapper';
import {EnergyPriceType} from './booth.model';
import {Salesunit} from './salesunit.model';
import {Marketdate} from './marketdate.model';
import { User } from './user.model';

export enum BoothType {
  Null = <any>'Null',
  Stall = <any>'Stall',
  Car = <any>'Car',
  Trailer = <any>'Trailer',
  Unknown = <any>'Unknown'
}

export class SalesunitTemp {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('name')
  public name?: string;

  @JsonProperty('salesunitNumber')
  public salesunitNumber?: number;

  @JsonProperty({ name: 'boothType', customConverter: {
      fromJson: (data: any) => {
        switch (data) {
          case 'Stall':
            data = BoothType.Stall;
            break;
          case 'Trailer':
            data = BoothType.Trailer;
            break;
          case 'Car':
            data = BoothType.Car;
            break;
          case 'Null':
          case 'Unknown':
          default:
            data = BoothType.Unknown;
            break;
        }
        return data;
      },
      toJson: (data: any) => { return data; }
    }})
  public boothType?: BoothType;

  @JsonProperty('boothWidth')
  public boothWidth?: number;

  @JsonProperty('boothDepth')
  public boothDepth?: number;

  @JsonProperty('boothSize')
  public boothSize?: number;

  @JsonProperty({ name: 'energyType', customConverter: {
      fromJson: (data: any) => {
        switch (data) {
          case 'None':
            data = EnergyPriceType.None;
            break;
          case 'Special':
            data = EnergyPriceType.Special;
            break;
          case 'Normal':
            data = EnergyPriceType.Normal;
            break;
          case 'Low':
            data = EnergyPriceType.Low;
            break;
          case 'Kein Stromverbraucher':
            data = EnergyPriceType.None;
            break;
          case 'Minderverbraucher':
            data = EnergyPriceType.Low;
            break;
          case 'Normalverbraucher':
            data = EnergyPriceType.Normal;
            break;
          case 'Sonderverbraucher':
            data = EnergyPriceType.Special;
            break;
          default:
            data = EnergyPriceType.Null;
            break;
        }
        return data;
      },
      toJson: (data: any) => { return data; }
    }})
  public energyType?: EnergyPriceType;

  @JsonProperty('identification')
  public identification?: string;

  @JsonProperty('assortment')
  public assortment?: string;

  @JsonProperty('assortmentAdditional')
  public assortmentAdditional?: string;

  @JsonProperty('assortmentExtended')
  public assortmentExtended?: string;

  @JsonProperty('assortmentExtendedAdditional')
  public assortmentExtendedAdditional?: string;

  @JsonProperty('contactFirstname')
  public contactFirstname?: string;

  @JsonProperty('contactLastname')
  public contactLastname?: string;

  @JsonProperty('contactMobile')
  public contactMobile?: string;

  @JsonProperty('boothWidthWinter')
  public boothWidthWinter?: number;

  @JsonProperty('boothDepthWinter')
  public boothDepthWinter?: number;

  @JsonProperty('boothSizeWinter')
  public boothSizeWinter?: number;

  @JsonProperty('assortmentKeys')
  public assortmentKeys?: string;

  @JsonProperty({ name: 'energyTypeWinter', customConverter: {
      fromJson: (data: any) => {
        switch (data) {
          case 'None':
            data = EnergyPriceType.None;
            break;
          case 'Special':
            data = EnergyPriceType.Special;
            break;
          case 'Normal':
            data = EnergyPriceType.Normal;
            break;
          case 'Low':
            data = EnergyPriceType.Low;
            break;
          case 'Kein Stromverbraucher':
            data = EnergyPriceType.None;
            break;
          case 'Minderverbraucher':
            data = EnergyPriceType.Low;
            break;
          case 'Normalverbraucher':
            data = EnergyPriceType.Normal;
            break;
          case 'Sonderverbraucher':
            data = EnergyPriceType.Special;
            break;
          default:
            data = EnergyPriceType.Null;
            break;
        }
        return data;
      },
      toJson: (data: any) => { return data; }
    }})
  public energyTypeWinter?: EnergyPriceType;

  @JsonProperty('winterStart')
  public winterStart?: any;

  @JsonProperty('winterEnd')
  public winterEnd?: any;

  @JsonProperty('merchantNumber')
  public merchantNumber?: string;

  @JsonProperty('merchantGguid')
  public merchantGguid?: string;

  @JsonProperty('updated')
  public updated?: string;

  @JsonProperty('updatedBy')
  public updatedBy?: Contact;

  @JsonProperty('created')
  public created?: string;

  @JsonProperty('gguid')
  public gguid?: string;

  @JsonProperty({clazz: Contact, name: 'merchant'})
  public merchant?: Contact;

  @JsonProperty({clazz: Contact, name: 'contactPerson'})
  public contactPerson?: Contact;

  @JsonProperty('powerConnection')
  public powerConnection?: string;

  @JsonProperty('status')
  public status?: string;

  @JsonProperty({clazz: Salesunit, name: 'originalSalesunit'})
  public originalSalesunit?: Salesunit;

  @JsonProperty({clazz: Marketdate, name: 'marketdate'})
  public marketdate?: Marketdate;

  @JsonProperty('statusArchive')
  public statusArchive?: string;

  @JsonProperty('archivedAt')
  public archivedAt?: string;

  @JsonProperty('archivedBy')
  public archivedBy?: User;

  @JsonProperty('useWinterSize')
  public useWinterSize?: boolean;

  @JsonProperty('licensePlate')
  public licensePlate?: string;

  @JsonProperty('marketdayNumber')
  public marketdayNumber?: string;

  @JsonProperty('marketdayKeyword')
  public marketdayKeyword?: string;

  @JsonProperty('changedAt')
  public changedAt?: string;

  @JsonProperty('changedBy')
  public changedBy?: Contact;

  constructor(initNull?: boolean) {
    this.id =  void 0;
    this.name = void 0;
    this.salesunitNumber =  void 0;
    this.boothType = void 0;
    this.boothWidth =  void 0;
    this.boothDepth =  void 0;
    this.boothSize =  void 0;
    this.energyType = void 0;
    this.identification = void 0;
    this.assortment = void 0;
    this.assortmentAdditional = void 0;
    this.assortmentExtended = void 0;
    this.assortmentExtendedAdditional = void 0;
    this.contactFirstname = void 0;
    this.contactLastname = void 0;
    this.contactMobile = void 0;
    this.boothWidthWinter =  void 0;
    this.boothDepthWinter =  void 0;
    this.boothSizeWinter =  void 0;
    this.energyTypeWinter = void 0;
    this.winterStart = void 0;
    this.winterEnd = void 0;
    this.merchantNumber = void 0;
    this.merchantGguid = void 0;
    this.updated = void 0;
    this.updatedBy = void 0;
    this.created = void 0;
    this.gguid = void 0;
    this.merchant = void 0;
    this.contactPerson = void 0;
    this.powerConnection = void 0;
    this.status = void 0;
    this.originalSalesunit = void 0;
    this.marketdate = void 0;
    this.statusArchive = void 0;
    this.archivedAt = void 0;
    this.archivedBy = void 0;
    this.useWinterSize = void 0;
    this.licensePlate = void 0;
    this.marketdayNumber = void 0;
    this.marketdayKeyword = void 0;
    this.changedAt = void 0;
    this.changedBy = void 0;
    this.assortmentKeys = void 0;

    if (initNull) {
      for (const key of Object.keys(this)) {
        this[key] = null;
      }
    }
  }

  getAssortments() {
    if (this.assortmentKeys) {
      return this.assortmentKeys.replace(/\s+/g, '').split(',');
    }
    return null;
  }
}




// WEBPACK FOOTER //
// ./src/app/entities/salesunit-temp.model.ts